import type { AccountRoleVM } from "@shared-kernel/application/ports/shared/shared-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveAccountRoles = createApiThunk<AccountRoleVM[], void>(
  "accounts/retrieveAccountRoles",
  async (_: void, { extra: { sharedRepository } }) => {
    return sharedRepository!.accountRoles();
  },
);
